module.exports = __webpack_public_path__ + "static/carousel-slide-07-3343a4c4dedafb16ccf470286b5af566.png";